
import { createApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";
import { Subscription, SubscriptionPackage } from "./types";
import { transformSubscription, transformSubscriptionPackage } from "./transformations";

/*---------------------------------------------------------------------------------------
  SET ACTIVE
-----------------------------------------------------------------------------------------*/

export const updateSubscriptionPackageActiveAPI = async (
  id: string,
): Promise<SubscriptionPackage> => {
  const response = await createApiCall(
    {
      path: `/v1/subscriptions`,
      method: "POST",
      body: {
        subscriptionPackageId: id
      },
    },
    {
      getMessage: {
        success: () => "Plan je uspješno ažuriran aktiviran",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformSubscriptionPackage(response.data);
};


/*---------------------------------------------------------------------------------------
    SETTING SUBSCRIPTION PACKAGE
-----------------------------------------------------------------------------------------*/
export const getSubscriptionPackagesAPI = async (): Promise<SubscriptionPackage[]> => {
  const response = await createApiCall(
    {
      path: `/v1/subscriptions/packages`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return response.data.map(transformSubscriptionPackage);
}


/*---------------------------------------------------------------------------------------
  SETTING SUBSCRIPTION PACKAGE ACIVE
-----------------------------------------------------------------------------------------*/
export const getSubscriptionPackageActiveAPI = async (): Promise<Subscription> => {
  const response = await createApiCall(
    {
      path: `/v1/subscriptions/active`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformSubscription(response.data);
};